import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useDictionaryEdit } from '@/module/Author/Dictionary/model/DictionaryQuery';
import {
  DictionarySchema,
  defaultDictionaryValues,
  dictionarySchema,
} from '@/module/Author/Dictionary/model/DictionarySchema';

import { useAppNotification } from '@feature/utils';

import { DictionaryForm } from './DictionaryForm';
import { Dictionary } from './model/DictionaryTypes';

interface DictionaryEditProps {
  dictionary: Dictionary;
}

const convert = (dictionary: Dictionary): DictionarySchema => ({
  ...dictionary,
});

export function DictionaryEdit(props: DictionaryEditProps) {
  const { dictionary } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useDictionaryEdit(dictionary.id);

  const notification = useAppNotification();
  const onSubmit = (values: DictionarySchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(dictionary), [dictionary]);
  const navigate = useNavigate();

  return (
    <DictionaryForm
      title={t('dictionaries.form.title.edit')}
      schema={dictionarySchema}
      defaultValues={defaultDictionaryValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
